var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F44336",
    d: "M9.19 10.518h.5V8.866c0-.654.224-1.202.687-1.671.462-.47.999-.695 1.636-.695s1.168.225 1.62.692c.455.469.678 1.018.678 1.674v1.652h1.08c.159 0 .292.053.423.186a.6.6 0 0 1 .186.439v5.732a.6.6 0 0 1-.186.44.56.56 0 0 1-.422.185H8.635a.59.59 0 0 1-.449-.186.6.6 0 0 1-.186-.439v-5.732a.6.6 0 0 1 .186-.44.59.59 0 0 1 .449-.185zm4.565 0h.5V8.866c0-.615-.225-1.156-.658-1.596A2.18 2.18 0 0 0 12 6.598c-.62 0-1.16.23-1.588.676-.424.441-.64.98-.64 1.592v1.652h3.983ZM12 15.66c.444 0 .836-.168 1.148-.484a1.62 1.62 0 0 0 .474-1.168 1.62 1.62 0 0 0-.474-1.168A1.57 1.57 0 0 0 12 12.357c-.444 0-.836.167-1.148.484a1.62 1.62 0 0 0-.474 1.168c0 .449.16.848.474 1.168.312.316.704.484 1.148.484Z"
  })));
};
export default SvgLock;